/* eslint-disable react-hooks/exhaustive-deps */
import { ConfigProvider, Flex, Form, message, Modal, Tabs } from "antd";
import dayjs from "dayjs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ChangeShiftTable from "components/table/ChangeShiftTable";
import CollectTimeTable from "components/table/CollectTimeTable";
import DocumentRequestTable from "components/table/DocumentRequestTable";
import EndorseTimeTable from "components/table/EndorseTimeTable";
import LeaveTable from "components/table/LeaveTable";
import OffsiteWorkTable from "components/table/OffsiteWorkTable";
import OvertimeTable from "components/table/OvertimeTable";
import RedeemTimeTable from "components/table/RedeemTimeTable";
import WarningLetterTable from "components/table/WarningLetterTable";


import { dataURLtoFile, generateRandomString } from "utils/helper";

import * as employeeServices from "features/employee/services/employeeApi";
import * as masterDataServices from "features/masterData/services/optionsApi";

import CollectTimeForm from "../components/CollectTimeForm";
import DocumentForm from "../components/DocumentForm";
import EndorseTimeForm from "../components/EndorseTimeForm";
import LeaveForm from "../components/LeaveForm";
import OffsiteForm from "../components/OffsiteForm";
import OvertimeForm from "../components/OvertimeForm";
import RedeemTimeForm from "../components/RedeemTimeForm";
import SwapShiftForm from "../components/SwapShiftForm";
import WarningLetterForm from "../components/WarningLetterForm";

// import { useParams } from "react-router-dom";
import duration from 'dayjs/plugin/duration';
import { useLocation, useParams } from "react-router-dom";
import * as service from "../../company/services/companyApi";
import {
  MY_REQUEST_TYPE
} from "../schemas/myRequestSchema";
import * as services from "../services/myDocumentApi";
import { setAttendanceSettingShifts, setCollectTime, setCompanyRegulations, setCurrentOvertime, setEmployeeSwapShift, setIsLoading, setMyDocumentList, setMyShift, setWorkInLocation } from "../slices/myDocumentSlice";
import ExpenseMainPage from "features/Expense/pages/ExpenseMainPage";
import ExpenseTableList from "features/Expense/components/ExpenseTableList";
import EditExpenseForm from "features/Expense/components/EditExpenseForm";
import ExpenseWorkflow from "features/Expense/components/ExpenseWorkflow";
import { setCommonTypeByCode, setdropdownProjectByEmployeeId, setDropdownWelfareSubTypeByCode, setEmployeeWelfareDropdown } from "features/Expense/slices/ExpenseSlices";
import useLeaveTypeEdit from "features/attendance/hooks/useLeaveTypeEdit";
import OvertimePayrollModal from "features/payment/components/OvertimePayrollModal";
import OvertimeRecalModal from "features/payment/components/OvertimePayrollModal";
const MODAL_TYPE = {
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
};

const FORMAT_DATE = "YYYY-MM-DD";

function useMyRequest() {
  const params = useParams();
  const location = useLocation()
  // const { id } = params;
  dayjs.extend(duration);
  function toParams(param) {
    const { pagination = {}, sortBy = [] } = param;
    const modifiedParams = {
      ...param,
      page: pagination.page || 0,
      size: pagination.pageSize || 10,
      sortBy: sortBy
        .filter((s) => s.order !== undefined)
        .map((s) => ({
          direction: s.order === "descend" ? "desc" : "asc",
          property: s.field,
        })),
    };
    return modifiedParams;
  }

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState("en");
  const dispatch = useDispatch();
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);
  // const currentWorking = useSelector((state) => state.myDocument.currentWorking);
  const currentOvertime = useSelector((state) => state.myDocument.currentOvertime);
  const [currentMyRequest, setCurrentMyRequest] = useState({});
  const [validateErr, setValidateErr] = useState();
  const [remainingLeaveDays, setremainingLeaveDays] = useState([]);
  const [swapChangeShift, setSwapChangeShift] = useState(null);
  const [useFilter, setUseFilter] = useState(false);
  const [isModalHistoryOpen, setIsModalHistoryOpen] = useState(false)
  const [isPDFLoading, setIsPDFLoading] = useState(false);

  const isLoading = useSelector((state) => state.myDocument.isLoading);
  const workInLocation = useSelector((state) => state.myDocument.workInLocation);
  const myDocumentList = useSelector(
    (state) => state.myDocument.myDocumentList || []
  );

  const collectTimeDropdown = useSelector(
    (state) => state.myDocument.collectTime || []
  );

  const companyRegulation = useSelector(
    (state) => state.myDocument.companyRegulations || []
  );

  const myShift = useSelector(
    (state) => state.myDocument.myShift || []
  );

  const employeeSwapShift = useSelector(
    (state) => state.myDocument.employeeSwapShift || {}
  );

  const attendanceSettingShifts = useSelector(
    (state) => state.myDocument.attendanceSettingShifts || {}
  );

  const [selectedMenu, setMenu] = useState(location.state?.initialMenu || MY_REQUEST_TYPE.LEAVE);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
  const [offSiteOptions, setOffSiteOptions] = useState([]);
  const [penaltiesOptions, setPenaltiesOptions] = useState([]);
  const [switchByOptions, setSwitchByOptions] = useState([]);
  const [switchWithOptions, setSwitchWithOptions] = useState([]);
  const [approver, setApprover] = useState([]);
  const [companyRegulationOptions, setCompanyRegulationOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [sorter, setSorter] = useState([]);
  const [modalType, setModalType] = useState(MODAL_TYPE.CREATE);
  const [isModalOpen, setModalOpen] = useState(false);
  const [startDate, setShiftStartDate] = useState();
  const [switchWith, setSwitchWith] = useState();
  const [changeShiftType, setChangeShiftType] = useState("SWAP");
  const [paramsSearch, setParamsSearch] = useState([]);
  const [files, setFiles] = useState([]);
  const { getDropdownWorkInLocationForOffsite = () => { } } = useLeaveTypeEdit();
  const [isWarningPdfLoading, setIsWarningPdfLoading] = useState(false);

  const [activeTabKey, setActiveTabKey] = useState("1");
  const [form] = Form.useForm();
  const { dropdownProjectByEmployeeId, EmployeeWelfareDropdown, CommonTypeByCode, dropdownWelfareSubTypeByCode } = useSelector((state) => state.expense);
  const [currentExpenseWorkflow, setCurrentExpenseWorkflow] = useState([]);

  // const [fileSizeInMB, setfileSizeInMB] = useState(0)
  // const [fileName, seeFileName] = useState('');
  // const [imageUrl, setImageUrl] = useState();
  // const [isProcessing, setIsProcessing] = useState(false);


  const [previousFile, setpreviousFilew] = useState(null);
  const onDeleteFile = () => {
    setpreviousFilew(null);
  }





  const onAttachFileChange = async ({
    attachFile,
    setFieldValue,
    setImageUrl,
    seeFileName,
    initialValuesImageUrl,
    initialValuesFileName,
    initialValuesFileType,
    initialValuesFileList,
    setInitialValuesFileName,
    setInitialValuesFileType,
    setInitialValuesImageUrl,
    setInitialValuesFileList,
    setFileType
  }) => {
    const fileUrls = [...initialValuesImageUrl];
    const fileNames = [...initialValuesFileName];
    const fileList = [...initialValuesFileList];
    const fileTypes = [...initialValuesFileType];
    const attachFileList = attachFile?.file;

    try {
      const allowedTypes = ["image/png", "image/jpeg", "application/pdf", "application/vnd.ms-excel"];
      const fileType = attachFileList?.type;
      const fileSize = attachFileList?.size;
      fileTypes.push(fileType)
      if (!allowedTypes.includes(fileType)) {
        Modal.error({
          title: "File Upload Error",
          content: "Unsupported file type. Only PNG, JPEG, XLS, and PDF are allowed.",
          okText: "Close",
          okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        });
        // setIsProcessing(false);
        return;
      }

      // const maxSize = 1 * 1024 * 1024;
      // // console.log("🚀 ~ useMyRequest ~ maxSize:", maxSize)
      // if (fileSize > maxSize) {
      //   Modal.error({
      //     title: "File Upload Error",
      //     content: "File size exceeds the 1 MB limit.",
      //     okText: "Close",
      //     okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      //   });
      //   // setIsProcessing(false);
      //   return;
      // }
      // console.log("fileType", fileType
      //   , fileUrls
      //   , fileNames
      //   , fileList
      // );

      if (fileType === "application/pdf" || fileType === "application/vnd.ms-excel") {
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(attachFileList?.originFileObj);
          reader.onload = () => resolve(reader.result);
        });

        const filename = `${Date.now()}_${attachFileList?.name}`;
        const file = dataURLtoFile(base64, filename);
        fileUrls.push(base64)
        fileNames.push(filename)
        fileList.push(file)
      } else {
        const compressImg = await service.compressedImage({
          file: attachFileList?.originFileObj,
        });

        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(compressImg.data);
          reader.onload = () => resolve(reader.result);
        });

        const filename = `${Date.now()}_${attachFileList?.name}`;
        const file = dataURLtoFile(base64, filename);

        fileUrls.push(base64)
        fileNames.push(filename)
        fileList.push(file)
      }
    } catch (error) {
      Modal.error({
        title: "File Upload Error",
        content: error.message,
        okText: "Close",
        okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      });
      // setIsProcessing(false);
      return;
    }
    // }

    setpreviousFilew(attachFileList);
    setFiles(fileList);
    seeFileName(fileNames);
    setInitialValuesFileName(fileNames);
    setInitialValuesFileType(fileTypes);
    setInitialValuesImageUrl(fileUrls);
    setInitialValuesFileList(fileList);
    setFieldValue("attachFile", fileList);
    setFieldValue("attachFileType", fileTypes);
    setFieldValue("attachFileName", fileNames);
    setImageUrl(fileUrls);
    setFileType(fileTypes)
  };


  // const getCompanyWorking = useCallback(async () => {
  //   try {
  //     dispatch(slices.setIsLoading(true));
  //     const response = await service.getWorkingCondition({
  //       requestId: generateRandomString(),
  //       companyId: currentCompany,
  //     });
  //     dispatch(slices.setCurrentWorking(response.data));

  //   } catch (error) {
  //     message.error(t("common.error"))
  //   } finally {
  //     dispatch(slices.setIsLoading(false));
  //   }
  // }, [currentCompany, dispatch]);



  const onSearch = useCallback(
    async (values = {}) => {
      try {
        dispatch(setMyDocumentList([]));
        dispatch(setIsLoading(true));
        let param = {
          ...values,
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params?.id ? params?.id : currentEmployee,
          approveStatusEn: values?.statusFlag
            ? [values?.statusFlag]
            : values?.approveStatusEn
              ? values?.approveStatusEn
              : null,
          collectDate: values?.collectDate?.format('YYYY-MM-DD'),
          redeemDate: values?.redeemDate?.format('YYYY-MM-DD'),
          // endorseMentDate: values?.endorseMentDate?.format('YYYY-MM-DD'),
          submissionDate: values?.submissionDate?.format('YYYY-MM-DD'),
          preferredDate: values?.preferredDate?.format('YYYY-MM-DD'),
          startDate: values?.startDate?.format('YYYY-MM-DD'),
          endDate: values?.endDate?.format('YYYY-MM-DD'),
          incidentDate: values?.incidentDate
            ? dayjs(values.incidentDate).startOf('day').toISOString()
            : undefined,
        };
        setParamsSearch(param)
        let type = 'SEARCH'

        const { response, total } = await (async () => {
          var response = null;
          switch (selectedMenu) {
            case MY_REQUEST_TYPE.LEAVE:
              response = await services.getLeaveRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.OFFSITE_WORK:
              response = await services.getOffsiteWorkRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.REDEEM_TIME:
              getCollectTime()
              response = await services.getRedeemTimeRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.ENDORSE_TIME:
              response = await services.getEndorseTimeRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.OVERTIME:
              response = await services.getOvertimeRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.COLLECT_TIME:

              response = await services.getCollectTimeRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
              response = await services.getDocumentRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.CHANGE_SHIFT:
              response = await services.getChangeShiftRequestPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.WARNING_LETTER:
              response = await services.getWarningLetterPagingRequest({
                ...param, type, page: 0, size: 10
              });
              return {
                response: response.data,
                total: response.data?.totalItems,
              };

            case MY_REQUEST_TYPE.EXPENSE:
              response = await services.getMyExpenseRequestPagination({
                ...param,
                type,
                page: param.page ?? 0,
                size: param.size ?? 10
              });
              return {
                response: {
                  content: response.data?.page?.content ?? [],
                  totalItems: response.data?.page?.totalElements,
                  pageNo: response.data?.page?.pageable?.pageNumber,
                  totalPages: response.data?.page?.totalPages,
                },
                total: response.data?.page?.totalElements,
              };

            default:
              return;
          }
        })();
        dispatch(setMyDocumentList(response.content || []));
        setPagination({
          ...pagination,
          current: response?.pageNo + 1,
          pageNo: response?.totalPages + 1,
          total: response?.totalItems,
        });
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
        getLeaveGroupOptions();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, currentCompany, params?.id, currentEmployee, pagination, selectedMenu]
  );

  const [openRecal, setOpenRecal] = useState(false)


  const onCreate = () => {
    setModalType(MODAL_TYPE.CREATE);
    setCurrentMyRequest({});
    setModalOpen(true);
    // setSwapChangeShift(null)
  };

  const onCancel = () => {
    setModalOpen(false);
    setShiftStartDate(null)
    setSwitchWith(null)
    setSwapChangeShift(null)

  };

  const onChangeShiftTypeChange = (e) => {
    setChangeShiftType(e)
  }

  //---------------- DATA HANDLING ----------------

  const getMyRequestList = useCallback(
    async (values = {}) => {
      try {
        dispatch(setIsLoading(true));
        dispatch(setMyDocumentList([]));
        let param = {
          ...values,
          ...paramsSearch,
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params?.id ? params?.id : currentEmployee,
        };
        const { response, total } = await (async () => {
          var response = null;
          switch (selectedMenu) {
            case MY_REQUEST_TYPE.LEAVE:
              response = await services.getLeaveRequestPagingRequest(param);
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.OFFSITE_WORK:
              response = await services.getOffsiteWorkRequestPagingRequest(
                param
              );
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.REDEEM_TIME:
              getCollectTime()
              response = await services.getRedeemTimeRequestPagingRequest(
                param
              );
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.ENDORSE_TIME:
              response = await services.getEndorseTimeRequestPagingRequest(
                param
              );
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.OVERTIME:
              response = await services.getOvertimeRequestPagingRequest(param);
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.COLLECT_TIME:

              response = await services.getCollectTimeRequestPagingRequest(
                param
              );
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
              response = await services.getDocumentRequestPagingRequest(param);
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.CHANGE_SHIFT:
              response = await services.getChangeShiftRequestPagingRequest(
                param
              );
              return {
                response: response.data,
                total: response.data?.totalItems,
              };
            case MY_REQUEST_TYPE.WARNING_LETTER:
              response = await services.getWarningLetterPagingRequest(param);
              return {
                response: response.data,
                total: response.data?.totalItems,
              };

            case MY_REQUEST_TYPE.EXPENSE:
              response = await services.getMyExpenseRequestPagination({
                ...param,
                page: param.page ?? 0,
                size: param.size ?? 10
              });
              return {
                response: {
                  content: response.data?.page?.content ?? [],
                  totalItems: response.data?.page?.totalElements,
                  pageNo: response.data?.page?.pageable?.pageNumber,
                  totalPages: response.data?.page?.totalPages,
                },
                total: response.data?.page?.totalElements,
              };
            default:
              return;
          }
        })();
        dispatch(setMyDocumentList(response.content || response.data?.page?.content || []));

        setPagination({
          ...pagination,
          current: response?.pageNo + 1,
          pageNo: response?.totalPages + 1,
          total: response?.totalItems,
        });
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [dispatch, currentCompany, params?.id, currentEmployee, pagination, selectedMenu]
  );

  const modalRecalOt = useCallback(
    () => {
      // onSearch()
      console.log(params.id);
      return <OvertimeRecalModal
        // payrollPeriod={state}
        form={form}
        isModalOpen={openRecal}
        onCancel={() => { setOpenRecal(false) }}
        onBack={() => { setOpenRecal(false) }}
        onFinish={async (val) => {
          const hide = message.loading(t("common.loading"), 0)

          await services.patchOvertimeRequest({
            employeeId: params?.id,
            startDate: val?.overtimePaymentDate?.[0]?.format("YYYY-MM-DD"),
            endDate: val?.overtimePaymentDate?.[1]?.format("YYYY-MM-DD")
          }).then(o => {
            getMyRequestList({
              page: 0,
              size: 10,
              type: 'SEARCH'
            });
            setOpenRecal(false)
          })
          hide()
          message.success(t("common.success"))
        }}
        action={"edit"}
      />
    },
    [onSearch, params, openRecal, getMyRequestList],
  )

  const getMyRequest = useCallback(async (record = {}) => {
    let param = {
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: params?.id ? params?.id : currentEmployee
    };
    let data = {};
    switch (selectedMenu) {
      case MY_REQUEST_TYPE.LEAVE:
        data = await services.getLeaveRequestByIdRequest({
          ...param,
          leaveRequestId: record.leaveRequestId,
        });
        return {
          ...data,
        };
      case MY_REQUEST_TYPE.OFFSITE_WORK:
        data = await services.getOffsiteWorkRequestByIdRequest({
          ...param,
          offsiteWorkRequestId: record.offsiteWorkRequestId,
        });
        return {
          ...data,
          startDate: dayjs(data?.startDate),
          endDate: dayjs(data.endDate),
        };
      case MY_REQUEST_TYPE.REDEEM_TIME:
        data = await services.getRedeemTimeRequestByIdRequest({
          ...param,
          redeemTimeRequestId: record.redeemTimeRequestId,
        });
        return {
          ...data,
          redeemDate: dayjs(data.redeemDate),
        };
      case MY_REQUEST_TYPE.ENDORSE_TIME:
        data = await services.getEndorseTimeRequestByIdRequest({
          ...param,
          endorseTimeRequestId: record.endorseTimeRequestId,
          endorseMentDate: record.endorseMentDate
        });
        return {
          ...data,
          endorseMentDate: dayjs(data?.timeEndorsementDate),
        };
      case MY_REQUEST_TYPE.OVERTIME:
        data = await services.getOvertimeRequestByIdRequest({
          ...param,
          overtimeRequestId: record.overtimeRequestId,
        });
        return {
          ...data,
          startDate: dayjs(data?.startDate),
        };
      case MY_REQUEST_TYPE.COLLECT_TIME:

        data = await services.getCollectTimeRequestByIdRequest({
          ...param,
          collectTimeRequestId: record.collectTimeRequestId,
        });
        return { ...data, startDate: dayjs(data.startDate) };
      case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
        data = await services.getDocumentRequestByIdRequest({
          ...param,
          documentRequestId: record.documentRequestId,
        });
        return {
          ...data,
          preferredDate: dayjs(data.preferredDate),
          travelDate: dayjs(data.travelDate),
        };
      case MY_REQUEST_TYPE.CHANGE_SHIFT:

        data = await services.getChangeShiftRequestByIdRequest({
          ...param,
          changeShiftRequestId: record.changeShiftRequestId,
        });
        return { ...data };
      case MY_REQUEST_TYPE.WARNING_LETTER: {
        const response = await services.getWarningLetterByIdRequest({
          ...param,
          warningLetterRequestId: record.warningLetterRequestId,
        });
        data = response?.data;

        const toDate = (v) => (v ? dayjs(v) : null);
        const getPositionName = (obj) =>
          lang === 'en' ? obj?.positionNameEn : obj?.positionName;

        return {
          data: {
            ...data,
            warningLetterRequestId: data.warningLetterRequestId,

            employeeId: data.warnedEmployee?.id,
            position: getPositionName(data.warnedEmployee),
            subject: data.companyRegulation?.id,
            subjectName:
              i18n.language === "en"
                ? data.companyRegulation?.nameEn
                : data.companyRegulation?.name,
            incidentStartDate: toDate(data.incidentDate),
            incidentEndDate: toDate(data.incidentEndDate),
            issueDate: toDate(data.issueDate),

            reasons: data.reasons || [],
            otherReasonDetail: data.otherReasonDetail,
            incidentDetail: data.incidentDetail,
            effectOnCompany: data.effectOnCompany,

            authorizedSigner: {
              employeeId: data.authorizedSigner?.id,
              positionName: data.authorizedSigner?.positionName,
              positionNameEn: data.authorizedSigner?.positionNameEn,
              signDate: toDate(data.authorizedSignerSignDate),
              useIssueDateAsSignDate: data.useIssueDateAsSignDate,
            },
            supervisor: {
              employeeId: data.supervisor?.id,
              positionName: data.supervisor?.positionName,
              positionNameEn: data.supervisor?.positionNameEn,
              signDate: toDate(data.supervisorSignDate),
              unspecified: data.supervisorUnspecified,
            },
            witness: {
              employeeId: data.witness?.id,
              positionName: data.witness?.positionName,
              positionNameEn: data.witness?.positionNameEn,
              signDate: toDate(data.witnessSignDate),
              unspecified: data.witnessUnspecified,
            },

            positionName: data.warnedEmployee?.positionName,
            positionNameEn: data.warnedEmployee?.positionNameEn,

            acknowledgedEmployee: {
              receivedDate: toDate(data.acknowledgedReceivedDate),
              notSignedYet: data.acknowledgedNotSignedYet,
            },

            startDate: toDate(data.startDate),
            endDate: toDate(data.endDate),
            createDate: toDate(data.createDate),
            effectiveDate: toDate(data.effectiveDate),
          }
        };
      }

      case MY_REQUEST_TYPE.EXPENSE:
        data = await services.getMyTxnExpenseById({
          ...param,
          txnExpenseId: record.id
        });
        return {
          data: data?.data?.content,
        }

      default:
        return {};
    }
  }, [selectedMenu, setMenu]);

  const myRequestAction = useCallback(
    async (params, isUpdate) => {
      console.log("🚀 ~ params:", params, typeof params?.attachFile?.[0])
      const selectedWarnedEmployeeId = params.employeeId;
      let fileCast = params?.attachFile?.filter(o => o.fileByte)?.map(o => dataURLtoFile(`data:${o.fileType};base64,${o.fileByte}`, o.fileName))
      console.log("params.attachFile", params.attachFile);

      if (fileCast && fileCast?.length > 0) {
        console.log("fileCast", fileCast);
        params.attachFile = fileCast
      }

      let fileCast2 = params?.attachFile?.filter(o => typeof o == 'string')?.map((o, index) => dataURLtoFile(`data:${params?.attachFileType[index]};base64,${o}`, params?.attachFileName[index]))
      console.log("params.attachFile", params.attachFile);

      if (fileCast2 && fileCast2?.length > 0) {
        console.log("fileCast", fileCast2);
        params.attachFile = fileCast2
      }

      let fileCast3 = params?.attachFileFs?.filter(o => o.fileByte)?.map(o => dataURLtoFile(`data:${o.fileType};base64,${o.fileByte}`, o.fileName))
      console.log("params.attachFile", params.attachFile);

      if (fileCast3 && fileCast3?.length > 0) {
        console.log("fileCast", fileCast3);
        params.attachFile = fileCast3
      }


      console.log("params.attachFile2", params.attachFile);

      params = {
        ...params,
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: currentEmployee,
      };
      let fileFs = params.attachFileFs
      delete params.attachFileFs
      try {
        dispatch(setIsLoading(true));
        const response = await (async () => {
          let requestBody = null;
          switch (selectedMenu) {
            case MY_REQUEST_TYPE.LEAVE:
              let adjustedStartDate = dayjs(params.startDate);
              let adjustedEndDate = dayjs(params.endDate);
              let diffInMilliseconds;
              let diffDuration;
              let hours;
              let minutes;
              if (params.durationType === 'HOUR') {
                const [startHour, startMinute] = params.startTime.split(':').map(Number);
                const [endHour, endMinute] = params.endTime.split(':').map(Number);
                if (startHour > endHour) {
                  adjustedStartDate = dayjs(params.startDate).hour(startHour).minute(startMinute);
                  adjustedEndDate = dayjs(params.endDate).hour(endHour).minute(endMinute).add(1, 'day');
                  diffInMilliseconds = adjustedEndDate.diff(adjustedStartDate);
                  diffDuration = dayjs.duration(diffInMilliseconds);
                  hours = diffDuration.hours();
                  minutes = diffDuration.minutes();

                }
              }

              requestBody = {
                ...params,
                leaveDate: params.leaveDate
                  ? dayjs(params.leaveDate).format(FORMAT_DATE)
                  : undefined,
                startDate: params.startDate
                  ? adjustedStartDate.format(FORMAT_DATE)
                  : undefined,
                endDate: params.endDate
                  ? adjustedEndDate.format(FORMAT_DATE)
                  : undefined,
                totalTimeHours: hours,
                totalTimeMinutes: minutes,
              };


              // if (requestBody.durationType !== 'ALLDAY' && requestBody?.startTime != null && requestBody?.endTime != null
              //   && dayjs(requestBody?.endTime, "HH:mm:ss").isBefore(dayjs(requestBody?.startTime, "HH:mm:ss").add(requestBody?.minimumLeave || 0, 'minute'))) {
              //   setValidateErr(t('my_request.label.validate_time_period'))
              //   return false
              // } else {
              // setValidateErr("")

              return isUpdate
                ? await services.updateLeaveRequest(requestBody)
                : await services.createLeaveRequest(requestBody);
            // await 
            // return false
            // }

            case MY_REQUEST_TYPE.OFFSITE_WORK:
              requestBody = {
                ...params,
                startDate: params.startDate
                  ? dayjs(params.startDate).format(FORMAT_DATE)
                  : undefined,
                endDate: params.endDate
                  ? dayjs(params.endDate).format(FORMAT_DATE)
                  : undefined,
              };
              // console.log("requestBody ", requestBody);
              // const diffTime = dayjs(requestBody?.endTime, "HH:mm:ss").diff(dayjs(requestBody?.startTime, "HH:mm:ss"), "minutes")
              // console.log("diffTime ", diffTime < requestBody?.minimumLeave)
              // if (requestBody.durationType !== 'ALLDAY' && requestBody?.startTime !== null && requestBody?.endTime !== null
              //   && dayjs(requestBody?.endTime, "HH:mm:ss").isBefore(dayjs(requestBody?.startTime, "HH:mm:ss").add(requestBody?.minimumLeave || 0, 'minute'))) {
              //   setValidateErr(t('my_request.label.validate_time_period') + t('translation.minumum-is') + requestBody?.minimumLeave + " " + t('unit.minutes'))
              //   return false
              // } else if (requestBody.durationType !== 'ALLDAY' && diffTime < requestBody?.minimumLeave) {
              //   setValidateErr("minimum request is " + requestBody?.minimumLeave)
              //   return false
              // } else {
              // setValidateErr()
              return isUpdate
                ? await services.updateOffsiteWorkRequest(requestBody)
                : await services.createOffsiteWorkRequest(requestBody);
            // }
            case MY_REQUEST_TYPE.REDEEM_TIME:
              requestBody = {
                ...params,
                redeemDate: params.redeemDate
                  ? dayjs(params.redeemDate).format(FORMAT_DATE)
                  : undefined,
              };
              return isUpdate
                ? await services.updateRedeemTimeRequest(requestBody)
                : await services.createRedeemTimeRequest(requestBody);
            case MY_REQUEST_TYPE.ENDORSE_TIME:
              requestBody = {
                ...params,
                endorseMentDate: params.endorseMentDate
                  ? dayjs(params.endorseMentDate).format(FORMAT_DATE)
                  : undefined,
              };
              return isUpdate
                ? await services.updateEndorseTimeRequest(requestBody)
                : await services.createEndorseTimeRequest(requestBody);
            case MY_REQUEST_TYPE.OVERTIME:
              requestBody = {
                ...params,
                startDate: params.startDate
                  ? dayjs(params.startDate).format(FORMAT_DATE)
                  : undefined,
                endDate: params.endDate
                  ? dayjs(params.endDate).format(FORMAT_DATE)
                  : undefined,
              };
              // console.log("requestBody", typeof requestBody.attachFile, requestBody.attachFile);
              // console.log("requestBody ss", requestBody?.attachFile?.filter(o => o.fileByte)?.map(o => dataURLtoFile(`data:${o.fileType};base64,${o.fileByte}`, o.fileName))



              // const file = dataURLtoFile(base64, filename);

              return isUpdate
                ? await services.updateOvertimeRequest(requestBody)
                : await services.createOvertimeRequest(requestBody);
            case MY_REQUEST_TYPE.COLLECT_TIME:
              requestBody = {
                ...params,

                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                collectDate: params.startDate
                  ? dayjs(params.startDate).format(FORMAT_DATE)
                  : undefined,
              };

              console.log("requestBody ", requestBody);
              return isUpdate
                ? await services.updateCollectTimeRequest(requestBody)
                : await services.createCollectTimeRequest(requestBody);
            case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
              requestBody = {
                ...params,
                preferredDate: params.preferredDate
                  ? dayjs(params.preferredDate).format(FORMAT_DATE)
                  : null,
                starttravelDate: Array.isArray(params?.rangevisaDate) && (params?.rangevisaDate[0] || params?.rangevisaDate[1])
                  ? dayjs(params?.rangevisaDate[0]).format(FORMAT_DATE)
                  : null,
                endtravelDate: Array.isArray(params?.rangevisaDate) && (params?.rangevisaDate[0] || params?.rangevisaDate[1])
                  ? dayjs(params?.rangevisaDate[1]).format(FORMAT_DATE)
                  : null,
                countryId: params.countryId
                // travelDate: params.RangevisaDate ?
                // dayjs(params.RangevisaDate).format(FORMAT_DATE)
                // :undefined
              };
              return isUpdate
                ? await services.updateDocumentRequest(requestBody)
                : await services.createDocumentRequest(requestBody);
            case MY_REQUEST_TYPE.CHANGE_SHIFT:
              requestBody = {
                ...params,
                startDate: params.startDate
                  ? dayjs(params.startDate).format(FORMAT_DATE)
                  : null,
                endDate: params.endDate
                  ? dayjs(params.endDate).format(FORMAT_DATE)
                  : null,
                description: params.other
              };
              return isUpdate
                ? await services.updateChangeShiftRequest({ ...requestBody, sendingType: requestBody.sendingType === "DRAFT" ? "PENDING" : requestBody.sendingType, shiftType: changeShiftType })
                : await services.createChangeShiftRequest({ ...requestBody, shiftType: changeShiftType });
            case MY_REQUEST_TYPE.WARNING_LETTER: {
              const formatDate = (v) => (v ? dayjs(v).format(FORMAT_DATE) : undefined);

              requestBody = {
                ...params,

                warnedEmployeeId: selectedWarnedEmployeeId,
                witnessId: params.witness?.employeeId,
                companyRegulationId: params.subject,

                IncidentDate: formatDate(params.incidentStartDate),
                incidentEndDate: formatDate(params.incidentEndDate),
                issueDate: formatDate(params.issueDate),

                incidentDetail: params.incidentDetail,
                effectOnCompany: params.effectOnCompany,

                reasons: params.reasons,
                otherReasonDetail: params.otherReasonDetail,

                authorizedSignerId: params.authorizedSigner?.employeeId,
                authorizedSignerSignDate: formatDate(params.authorizedSigner?.signDate),
                useIssueDateAsSignDate: params.authorizedSigner?.useIssueDateAsSignDate,

                supervisorId: params.supervisor?.employeeId,
                supervisorSignDate: formatDate(params.supervisor?.signDate),
                supervisorUnspecified: params.supervisor?.unspecified,

                witnessSignDate: formatDate(params.witness?.signDate),
                witnessUnspecified: params.witness?.unspecified,

                acknowledgedReceivedDate: formatDate(params.acknowledgedEmployee?.receivedDate),
                acknowledgedNotSignedYet: params.acknowledgedEmployee?.notSignedYet,

                startDate: formatDate(params.startDate),
                endDate: formatDate(params.endDate),
                effectiveDate: formatDate(params.effectiveDate),
                fine: "0",
              };

              return isUpdate
                ? await services.updateWarningLetterRequest(requestBody)
                : await services.createWarningLetterRequest(requestBody);
            }
            default:
              return;
          }
        })();

        // console.log("🚀 ~ response:", response)

        if (response?.data?.content?.code === '200') {
          message.success(t("common.success"))
          setModalOpen(false);
          await getLeaveGroupOptions();
        } else {
          function contentDetail() {
            return response?.data?.content?.details?.map?.(o => {
              return <span>{o?.value?.split('\n').map((line, index) => (
                <div>
                  {line}
                  <br />
                </div>
              ))}</span>
            })
          }
          // if (validateErr !== "") {
          // console.log("validateErr ", validateErr)

          Modal.error({
            content: (contentDetail(validateErr)),
            okText: t("confirm"),
            okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
          })

          // }
        }
        // setModalOpen(false);
        getMyRequestList({
          page: 0,
          size: 10,
          type: 'SEARCH'
        });
      } catch (error) {
        console.log("error ", error);
        const errData = error?.response?.data;
        if (errData) {
          const fieldErrors = errData.content && typeof errData.content === "object"
            ? Object.entries(errData.content).map(([field, msg]) => (
              <div key={field}>{field}: {msg}</div>
            ))
            : null;

          Modal.error({
            content: (
              <div>
                {fieldErrors || errData.status?.description || t("common.error")}
              </div>
            ),
            okText: t("confirm"),
            okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
          });
        } else {
          message.error(t("common.error"));
        }
      }
    },
    [selectedMenu, currentCompany, currentEmployee, changeShiftType, validateErr, dispatch, getMyRequestList]
  );

  function onDraft(values) {
    onSubmit(values, undefined, "DRAFT");
  }
  const onPreviewPdf = useCallback(async (values) => {
    try {
      dispatch(setIsLoading(true));
      const payload = {
        warnedEmployeeId: values.employeeId,
        subject: values.subject,
        incidentStartDate: values.incidentStartDate?.format("YYYY-MM-DD"),
        incidentEndDate: values.incidentEndDate?.format("YYYY-MM-DD"),
        issueDate: values.issueDate?.format("YYYY-MM-DD"),
        incidentDetail: values.incidentDetail,
        reasons: values.reasons,
        otherReasonDetail: values.otherReasonDetail,
        authorizedSigner: {
          employeeId: values.authorizedSigner?.employeeId,
          signDate: values.authorizedSigner?.signDate?.format("YYYY-MM-DD"),
          useIssueDateAsSignDate: values.authorizedSigner?.useIssueDateAsSignDate,
        },
        supervisor: {
          employeeId: values.supervisor?.employeeId,
          signDate: values.supervisor?.signDate?.format("YYYY-MM-DD"),
          unspecified: values.supervisor?.unspecified,
        },
        witness: {
          employeeId: values.witness?.employeeId,
          signDate: values.witness?.signDate?.format("YYYY-MM-DD"),
          unspecified: values.witness?.unspecified,
        },
        acknowledgedEmployee: {
          receivedDate: values.acknowledgedEmployee?.receivedDate?.format("YYYY-MM-DD"),
          notSignedYet: values.acknowledgedEmployee?.notSignedYet,
        },
        lang: i18n.language,
        companyId: currentCompany,
      };

      const response = await services.previewWarningLetterPdf(payload);
      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(blobUrl, "_blank"); // เปิด tab ใหม่ตามที่ต้องการ
    } catch (error) {
      message.error(t("common.error"));
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, i18n.language]);

  const onDownloadWarningLetter = useCallback(async (values) => {
    setIsWarningPdfLoading(true);
    try {
      const payload = {
        warnedEmployeeId: values.employeeId,
        subject: values.subject,
        incidentStartDate: values.incidentStartDate?.format("YYYY-MM-DD"),
        incidentEndDate: values.incidentEndDate?.format("YYYY-MM-DD"),
        issueDate: values.issueDate?.format("YYYY-MM-DD"),
        incidentDetail: values.incidentDetail,
        reasons: values.reasons,
        otherReasonDetail: values.otherReasonDetail,
        authorizedSigner: {
          employeeId: values.authorizedSigner?.employeeId,
          signDate: values.authorizedSigner?.signDate?.format("YYYY-MM-DD"),
          useIssueDateAsSignDate: values.authorizedSigner?.useIssueDateAsSignDate,
        },
        supervisor: {
          employeeId: values.supervisor?.employeeId,
          signDate: values.supervisor?.signDate?.format("YYYY-MM-DD"),
          unspecified: values.supervisor?.unspecified,
        },
        witness: {
          employeeId: values.witness?.employeeId,
          signDate: values.witness?.signDate?.format("YYYY-MM-DD"),
          unspecified: values.witness?.unspecified,
        },
        acknowledgedEmployee: {
          receivedDate: values.acknowledgedEmployee?.receivedDate?.format("YYYY-MM-DD"),
          notSignedYet: values.acknowledgedEmployee?.notSignedYet,
        },
        lang: i18n.language,
        companyId: currentCompany,
      };

      const response = await services.previewWarningLetterPdf(payload);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Warning-Letter-${values.sequence || values.warningLetterRequestId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error(t("common.error"));
    } finally {
      setIsWarningPdfLoading(false);
    }
  }, [currentCompany, i18n.language]);
  const onSubmit = useCallback(
    (values, cb = () => { }, targetStatus = "SUBMIT") => {


      if (remainingLeaveDays === '0') {
        Modal.error({
          title: "สิทธิ์การลาไม่เพียงพอ",
          content: "เนื่องจากเกินสิทธิ์การลาที่มี กรุณาตรวจสอบใหม่อีกครั้ง",
          okText: "ตกลง",
          okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        });
        return;
      } else {
        try {
          const fileList = []
          // if (values.sendingType === "DRAFT") {
          // for (let index = 0; index < values?.attachFile?.length; index++) {
          //   const element = values?.attachFile?.[index];
          //   const filename = values?.attachFileName?.[index];
          //   console.log('element', element);

          //   if (element instanceof File) {
          //     fileList.push(element)
          //   } else {
          //     const dataURL = `data:${values.attachFileType[index]};base64,${element}`;
          //     const file = dataURLtoFile(dataURL, filename);
          //     fileList.push(file)
          //   }
          // }
          // values.attachFile = fileList
          // }

          Modal.confirm({
            title: t('dialog.confirmation.header'),
            content: (
              <>
                <p>
                  {t('myRequest.are-you-sure-confirm-to')}
                  {modalType === MODAL_TYPE.CREATE ? t('useRequest.create') : t('useRequest.edit')}
                  {t('useRequest.the-data')}
                </p>

              </>
            ),
            onOk() {
              values.sendingType = targetStatus;

              let isUpdate = false;
              if (
                values.leaveRequestId ||
                values.offsiteWorkRequestId ||
                values.redeemTimeRequestId ||
                values.endorseTimeRequestId ||
                values.overtimeRequestId ||
                values.collectTimeRequestId ||
                values.documentRequestId ||
                values.changeShiftRequestId ||
                values.warningLetterRequestId
              ) {
                isUpdate = true;
              }

              myRequestAction(values, isUpdate);
              // cb?.();
              console.log("🚀 ~ onOk ~ values.sendingType:", values.sendingType)
              console.log("🚀 ~ onOk ~ values:", values)

            },
            okText: t('confirm-2'),
            cancelText: t('masterData.cancel'),
            okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
            cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
          });
        } catch (error) {
          console.log("error", error);

        }

      }
    },
    [modalType, myRequestAction, remainingLeaveDays, leaveGroupOptions]
  );

  const sendRejectFlowForHr = useCallback(async (value) => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          ...value,
          companyId: currentCompany,
          employeeId: currentEmployee,
        };
        // console.log("location", location);
        // "/employee/673d6035570ecb2f59f908da/document"

        if (location.pathname.match("^\/employee\/.*.\/document$")) {
          const response = await services.rejectFlowForHr(values);
        } else if (location.pathname.match("^\/my_document\/my_request$")) {
          const response = await services.rejectFlowForCustomer(values);
        }
        onCancel()
        setCurrentMyRequest({});
        getMyRequestList({
          page: 0,
          size: 10,
          type: 'SEARCH'
        });
        message.success(t("common.success"))
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, location, dispatch, getMyRequestList]);

  const onReject = useCallback(
    (values) => {
      try {
        // if (values.sendingType === "DRAFT") {
        Modal.confirm({
          title: t('dialog.confirmation.header'),
          content: (
            <>
              <p>
                {t('myRequest.are-you-sure-confirm-to')}
                {/* {modalType === MODAL_TYPE.CREATE ? t('useRequest.create') : t('useRequest.edit')} */}
                {`${t('common.reject')} ?`}

              </p>

            </>
          ),
          onOk() {
            if (values.sendingType == null) values.sendingType = "SUBMIT";

            let isUpdate = false;
            if (
              values.leaveRequestId ||
              values.offsiteWorkRequestId ||
              values.redeemTimeRequestId ||
              values.endorseTimeRequestId ||
              values.overtimeRequestId ||
              values.collectTimeRequestId ||
              values.documentRequestId ||
              values.changeShiftRequestId ||
              values.warningLetterRequestId ||
              values.id
            ) {
              isUpdate = true;
            }

            let requestId = values.leaveRequestId ||
              values.offsiteWorkRequestId ||
              values.redeemTimeRequestId ||
              values.endorseTimeRequestId ||
              values.overtimeRequestId ||
              values.collectTimeRequestId ||
              values.documentRequestId ||
              values.changeShiftRequestId ||
              values.warningLetterRequestId ||
              values.id

            // myRequestAction(values, isUpdate);
            console.log(" ~ onOk ~ values:", requestId, values.descriptionReject)
            sendRejectFlowForHr({ requestId, descriptionReject: values.descriptionReject })
          },
          okText: t('confirm-2'),
          cancelText: t('masterData.cancel'),
          okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
          cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
        });
      } catch (error) {
        console.log("error", error);

      }

    },
    [modalType, sendRejectFlowForHr, getMyRequestList]
  );

  const handleDelete = useCallback(
    async (record) => {
      try {
        console.log("DELETING !!");
        console.log(selectedMenu);
        console.log(record);
        dispatch(setIsLoading(true));
        const params = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
          statusFlag: "DELETE",
        };

        let requestBody = {};
        switch (selectedMenu) {
          case MY_REQUEST_TYPE.LEAVE:
            requestBody = {
              ...params,
              reqId: record.leaveRequestId,
              reqType: MY_REQUEST_TYPE.LEAVE
            };
            await services.deleteAllRequestByReqId(requestBody);
            break;
          case MY_REQUEST_TYPE.OFFSITE_WORK:
            requestBody = {
              ...params,
              reqId: record.offsiteWorkRequestId,
              reqType: MY_REQUEST_TYPE.OFFSITE_WORK
            };
            await services.deleteAllRequestByReqId(requestBody);
            break;
          case MY_REQUEST_TYPE.REDEEM_TIME:
            requestBody = {
              ...params,
              redeemTimeRequestId: record.redeemTimeRequestId,
            };
            // await services.manageRedeemTimeRequestStatus(requestBody);
            break;
          case MY_REQUEST_TYPE.ENDORSE_TIME:
            requestBody = {
              ...params,
              reqId: record.endorseTimeRequestId,
              reqType: MY_REQUEST_TYPE.ENDORSE_TIME
            };
            await services.deleteAllRequestByReqId(requestBody);
            break;
          case MY_REQUEST_TYPE.OVERTIME:
            requestBody = {
              ...params,
              reqId: record.overtimeRequestId,
              reqType: MY_REQUEST_TYPE.OVERTIME
            };
            await services.deleteAllRequestByReqId(requestBody);
            break;
          case MY_REQUEST_TYPE.COLLECT_TIME:
            requestBody = {
              ...params,

              collectTimeRequestId: record.collectTimeRequestId,
            };
            // await services.manageCollectTimeRequestStatus(requestBody);
            break;
          case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
            requestBody = {
              ...params,
              documentRequestId: record.documentRequestId,
            };
            // await services.manageDocumentRequestStatus(requestBody);
            break;
          case MY_REQUEST_TYPE.CHANGE_SHIFT:
            requestBody = {
              ...params,
              changeShiftRequestId: record.changeShiftRequestId,
            };
            // await services.manageChangeShiftRequestStatus(requestBody);
            break;
          case MY_REQUEST_TYPE.WARNING_LETTER:
            requestBody = {
              ...params,
              warningLetterRequestId: record.warningLetterRequestId,
            };
            // await services.manageWarningLetterRequestStatus(requestBody);
            break;
          default:
            break;
        }

        message.success(t("common.success"))
        setModalOpen(false);
        const modifiedParams = toParams({
          page: pagination.page - 1,
          pageSize: pagination.size,
          sortBy: sorter,
          type: 'SEARCH'
        });
        getMyRequestList(modifiedParams);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, pagination, sorter, dispatch]
  );

  const onDelete = useCallback(
    (record) => {
      console.log("🚀 ~ useMyRequest ~ record:", record)
      Modal.confirm({
        title: t('confirmation-1'),
        content: (
          <>
            <p>{t('dialog.confirmation.delete')}</p>
          </>
        ),
        onOk() {
          handleDelete(record);
        },
        okText: t('confirm-2'),
        cancelText: t('masterData.cancel'),
        okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
      });
    },
    [handleDelete]
  );

  const onSwitchWithChange = useCallback((e) => {
    setSwitchWith(e)
  }, [switchWith])

  const onDateChange = useCallback((e) => {
    setShiftStartDate(dayjs(e))
  }, [startDate])

  const getMyShift = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getCurrentShift({
        companyId: currentCompany,
        employeeId: currentEmployee,
        startDate: dayjs(startDate).format("YYYY-MM-DD")
      })
      dispatch(setMyShift(response?.data))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany,
    currentEmployee,
    startDate])

  const getEmployeeSwapShift = useCallback(async () => {
    try {
      // console.log("currentCompany ", switchWith);
      dispatch(setIsLoading(true));
      const response = await services.getCurrentShift({
        companyId: currentCompany,
        employeeId: switchWith?.empId,
        startDate: dayjs(startDate).format("YYYY-MM-DD")
      })
      dispatch(setEmployeeSwapShift(response?.data))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, switchWith, startDate])

  const modifiedMyShift = useMemo(() => {
    if (currentMyRequest?.currentShiftId) {
      return [{
        value: currentMyRequest?.currentShiftId?.shiftId,
        label: lang === 'en' ? currentMyRequest?.currentShiftId?.shiftNameEn : currentMyRequest?.currentShiftId?.shiftName,
        ...currentMyRequest?.currentShiftId
      }]
    } else {
      return startDate ? [{
        value: myShift?.shiftId,
        label: lang === 'en' ? myShift?.shiftNameEn : myShift?.shiftName,
        ...myShift
      }] : []
    }
  }, [lang, getMyShift, myShift, currentMyRequest, getMyRequest])

  const modifiedEmployeeSwapShift = useMemo(() => {
    if (currentMyRequest?.newShiftRequestId) {
      return [{
        value: currentMyRequest?.newShiftRequestId?.shiftId,
        label: lang === 'en' ? currentMyRequest?.newShiftRequestId?.shiftNameEn : currentMyRequest?.newShiftRequestId?.shiftName,
        ...currentMyRequest?.newShiftRequestId
      }]
    } else {
      return startDate ? [{
        value: employeeSwapShift?.shiftId,
        label: lang === 'en' ? employeeSwapShift?.shiftNameEn : employeeSwapShift?.shiftName,
        ...employeeSwapShift
      }] : []
    }
  }, [lang, getEmployeeSwapShift, employeeSwapShift, currentMyRequest])




  const modifiedApprover = useMemo(() => {
    if (currentMyRequest?.approver) {
      return [{
        value: currentMyRequest?.approver?.id,
        label: lang === 'en'
          ? `${currentMyRequest?.approver?.nameEn} ${currentMyRequest?.approver?.surNameEn}`
          : `${currentMyRequest?.approver?.name} ${currentMyRequest?.approver?.surName}`,
        ...currentMyRequest?.approver
      }];
    } else {
      return [{
        value: approver?.empId,
        label: lang === 'en'
          ? `${approver?.nameEn} ${approver?.surNameEn}`
          : `${approver?.name} ${approver?.surName}`,
        ...approver
      }];
    }
  }, [lang, onSwitchWithChange, approver, currentMyRequest]);


  //---------------- Dropdowns ----------------

  const modifiedLeaveGroupOptions = useMemo(() => {
    return leaveGroupOptions?.map((opt) => ({

      ...opt,
      unlimited: opt?.unlimited ? opt?.unlimited : 'N',
      emergencyFlag: opt?.emergencyFlag ? opt?.emergencyFlag : 'N',
      emergencyUsed: opt?.emergencyUsed ? opt?.emergencyUsed : 0,
      remainingLeaveDays: opt?.remainingLeaveDays,
      remainingLeaveHour: opt?.remainingLeaveHour,
      label: lang === "en" ? opt?.leaveTypeNameEn : opt?.leaveTypeName,
      value: opt?.leaveId,
    }));
  }, [lang, leaveGroupOptions]);




  const getLeaveGroupOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params?.id ? params?.id : currentEmployee,
        };
        const response = await masterDataServices.getLeaveGroupIsLeave(values);
        setLeaveGroupOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, dispatch]);



  const modifiedOffSiteOptions = useMemo(() => {
    return offSiteOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, offSiteOptions]);

  const getOffSiteOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params?.id ? params?.id : currentEmployee,
        };
        const response = await masterDataServices.getLeaveGroupIsOffSite(
          values
        );
        setOffSiteOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);



  const modifiedEmployeeOptions = useMemo(() => {
    return employeeOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.fullNameEn : opt?.fullName,
      value: opt?.id,
    }));
  }, [lang, employeeOptions]);

  const getEmployeeOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await employeeServices.getDropDown(values);
        setEmployeeOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);

  const modifiedPenaltiesOptions = useMemo(() => {
    return penaltiesOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, penaltiesOptions]);

  const getPenaltiesOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await masterDataServices.getPenaltiesOptions(values);
        setPenaltiesOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);


  const modifiedSwitchByOptions = useMemo(() => {
    return switchByOptions
      ?.filter(opt => opt?.id === currentEmployee)  // Return true if the condition is met
      .map((opt) => ({
        ...opt,
        label: lang === "en" ? opt?.nameEn + " " + opt?.surNameEn : opt?.name + " " + opt?.surName,
        value: opt?.id,
      }));
  }, [lang, switchByOptions, currentEmployee]);


  const getCompanyOvertime = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getOvertimeCondition({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      // console.log(response.data)
      dispatch(setCurrentOvertime(response.data));
      // console.log(currentOvertime.otReqCondition);
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);



  const getSwitchByOptionsOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params?.id ? params?.id : currentEmployee,
        };
        const response = await masterDataServices.getSwitchBy(values);
        setSwitchByOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, dispatch]);




  const modifiedSwitchWithOptions = useMemo(() => {
    // console.log("switchWithOptions", switchWithOptions);
    return switchWithOptions?.map((opt) => ({
      ...opt,
      label: lang === "en"
        ? `${opt?.nameEn} ${opt?.surNameEn}`
        : `${opt?.name} ${opt?.surName}`,
      value: opt?.empId,
    }));
  }, [lang, switchWithOptions]);

  const getSwitchWithOptionsOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params?.id ? params?.id : currentEmployee,
        };
        const response = await masterDataServices.getEmployeSubOrdinates(values);
        // console.log("values", response.data?.supervisorDetails);

        setSwitchWithOptions(response.data?.subOrdinateDetailsList);
        setApprover(response.data?.supervisorDetails);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, dispatch]);


  const modifiedCompanyRegulationOptions = useMemo(() => {
    return companyRegulation?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, companyRegulation]);

  const getCompanyRegulationOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await masterDataServices.getCompanyRegulationOptions(
          values
        );
        setCompanyRegulationOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);


  const modifiedDocumentTypeOptions = useMemo(() => {
    return documentTypeOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, documentTypeOptions]);

  const getDocumentTypeOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await masterDataServices.getDocumentTypeOptions(
          values
        );
        setDocumentTypeOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);


  const modifiedCollectTimeOptions = useMemo(() => {
    return collectTimeDropdown?.map((opt) => (
      {
        ...opt,
        label: opt?.collectDate,
        value: opt?.id,
      }
    ))
  }, [collectTimeDropdown])

  const modifiedCountryOptions = useMemo(() => {
    return countryOptions?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [lang, countryOptions]);

  const getCountryOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
        };
        const response = await masterDataServices.getCountryOptions(values);
        setCountryOptions(response.data);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);




  const getAttendanceSettingShift = useCallback(async () => {
    try {
      const response = await services.getAttendanceSettingShift({
        companyId: currentCompany,
        employeeId: params?.id ? params?.id : currentEmployee,
        actionId: currentEmployee,
      })
      dispatch(setAttendanceSettingShifts(response?.data))
    } catch (error) {
      message.error(t("common.error"))
    }
  }, [currentCompany, currentEmployee, dispatch])

  const getExpenseWorkflow = useCallback(async (expenseData) => {
    const target = expenseData ?? currentMyRequest;
    let data = [];
    if (currentMyRequest?.approveStatusEn !== 'Draft') {
      data = await services.getWorkflowByRequestId({
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: params?.id ? params?.id : currentEmployee,
        flowRequestId: target?.id,
      });
      setCurrentExpenseWorkflow(data?.data?.approvalSequence)
    }
  }, [currentCompany, currentEmployee, currentMyRequest])

  const getdropdownProjectByEmployeeId = useCallback(async () => {
    if (!currentCompany || !currentEmployee) return;
    dispatch(setIsLoading(true));
    try {
      const response = await services.dropdownProjectByEmployeeId({
        companyId: currentCompany,
        employeeId: currentEmployee,
      });
      dispatch(setdropdownProjectByEmployeeId(response.data?.content || []));
    } catch (error) {
      message.error(error.message || "เกิดข้อผิดพลาดในการโหลดโปรเจค");
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const getEmployeeWelfareDropdown = useCallback(async () => {
    if (!currentCompany || !currentEmployee) return;
    dispatch(setIsLoading(true));
    try {
      const response = await services.getEmployeeWelfareDropdown({
        companyId: currentCompany,
        employeeId: currentEmployee,

      });
      dispatch(setEmployeeWelfareDropdown(response.data?.content || []));
    } catch (error) {
      message.error(error.message || "เกิดข้อผิดพลาดในการโหลดประเภทค่าใช้จ่าย");
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const getCommonTypeByCode = useCallback(async () => {
    if (!currentCompany || !currentEmployee) return;
    dispatch(setIsLoading(true));
    try {
      const response = await services.getCommonTypeByCode({
        companyId: currentCompany,
        employeeId: currentEmployee,
        groupType: "TRANSPORT",
      });
      dispatch(setCommonTypeByCode(response.data || []));

    } catch (error) {
      message.error(error.message || "เกิดข้อผิดพลาดในการโหลดโปรเจค");
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch,]);

  const modifiedWelfareType = useMemo(() => {
    const modifiedOptions = EmployeeWelfareDropdown?.map((opt) => ({
      value: opt?.id,
      label: i18n.language === "en" ? opt?.welfareNameEn : opt?.welfareName,
      code: opt.subcategoryDetails?.code,
      remainingRequest: opt?.remainingRequest,
      remainingCredit: opt?.remainingCredit
    }));
    return modifiedOptions;
  }, [EmployeeWelfareDropdown, i18n.language]);

  const modifiedCommonTypeByCode = useMemo(() => {
    const modifiedOptions = CommonTypeByCode?.map((opt) => ({
      value: opt?.id,
      label: i18n.language === "en" ? opt?.nameEn : opt?.name,
      // code: opt?.code
    }));
    return modifiedOptions;
  }, [CommonTypeByCode, i18n.language]);

  const modifiedWorkInLocationOption = useMemo(() => {
    return workInLocation?.map((opt) => ({
      ...opt,
      value: opt?.workInLocationId,
      label: opt?.workInLocationName
    }
    ))
  }, [lang, workInLocation])

  const modifiedAttendanceSettingShift = useMemo(() => {
    if (Object.keys(attendanceSettingShifts).length === 0) {
      return null;
    } else {
      return attendanceSettingShifts?.map((opt) => ({
        ...opt,
        value: opt?.id,
        label: lang === 'en' ? opt?.shiftNameEn : opt?.shiftName
      }
      ))
    }
  }, [lang, getAttendanceSettingShift, attendanceSettingShifts])

  const getDropdownWelfareSubTypeByCode = useCallback(async () => {
    if (!currentCompany || !currentEmployee) return;
    dispatch(setIsLoading(true));
    try {
      const response = await services.getDropdownWelfareSubTypeByCode({
        companyId: currentCompany,
        employeeId: currentEmployee,
        code: "WELFARE_SUBCATEGORY",
      });
      dispatch(setDropdownWelfareSubTypeByCode(response.data?.content || []));
    } catch (error) {
      message.error(error.message || "เกิดข้อผิดพลาดในการโหลดประเภทค่าใช้จ่าย");
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);


  const modifiedWelfare = useMemo(() => {
    const modifiedOptions = dropdownWelfareSubTypeByCode?.map((opt) => ({
      value: opt?.id,
      label: i18n.language === "en" ? opt?.nameEn : opt?.name,
      code: opt?.code
    }));
    return modifiedOptions;
  }, [dropdownWelfareSubTypeByCode, i18n.language]);

  const onEdit = useCallback(async (record) => {
    setModalType(MODAL_TYPE.EDIT);
    let editingData = await getMyRequest(record);
    setCurrentMyRequest({ ...editingData?.data });
    setSwapChangeShift(editingData?.changeShiftType);
    setModalOpen(true);
  }, [getMyRequest, setSwapChangeShift])

  const onView = useCallback(async (record, reject) => {
    setModalType(MODAL_TYPE.VIEW);
    let editingData = await getMyRequest(record);

    if (selectedMenu === MY_REQUEST_TYPE.EXPENSE) {
      const data = editingData?.data;
      setCurrentMyRequest({
        ...data,
        reject,
        welfareTypeId: data?.welfareTypeId ?? data?.welfare?.welfareTypeId,
        travelBy: data?.travelBy?.id ?? data?.travelBy,
        projectId: data?.projectId || null
      });
      setSwapChangeShift(data?.changeShiftType);
      getdropdownProjectByEmployeeId();
      getEmployeeWelfareDropdown();
      getCommonTypeByCode();

      if (data?.id && (data?.approveStatusEn !== 'Draft')) {
        getExpenseWorkflow(data);
      }

    } else {
      setCurrentMyRequest({
        ...editingData?.data,
        reject,
        ...(selectedMenu === MY_REQUEST_TYPE.DOCUMENT_REQUEST && {
          ableToDownload: record?.ableToDownload
        })
      });
      setSwapChangeShift(editingData?.changeShiftType);
    }

    setModalOpen(true);
  }, [
    getMyRequest,
    selectedMenu,
    getdropdownProjectByEmployeeId,
    getEmployeeWelfareDropdown,
    getCommonTypeByCode,
  ]);

  const exportDocumentRequest = useCallback(
    async (fileName, employeeId) => {
      setIsPDFLoading(true);
      try {
        dispatch(setIsLoading(true));
        const res = await services.exportDocumentRequestPDF({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: employeeId,
          documentRequestId: currentMyRequest?.documentRequestId
        })
        const url = window.URL.createObjectURL(res?.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error fetching report history:", error);
      } finally {
        dispatch(setIsLoading(false));
        setIsPDFLoading(false);
      }
    },
    [currentCompany, currentEmployee, currentMyRequest, dispatch]
  );

  const onOffsiteWorkTypeChange = useCallback(async (values) => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getDropdownWorkInLocation({
        companyId: currentCompany,
        employeeId: values?.employeeId ? values.employeeId : currentEmployee,
        leaveTypeCompanyId: values?.id
      })
      dispatch(setWorkInLocation(response?.data?.content))

    } catch (error) {
      console.log("error message : ", error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany,
    currentEmployee])
  //--------------------------------

  const modalProps = useMemo(() => {
    switch (selectedMenu) {

      case MY_REQUEST_TYPE.LEAVE:
        return {
          title:
            <Flex vertical>
              <Flex gap={8}>
                <span>{t('leave-request')}</span>
                <span>{(modalType == MODAL_TYPE.EDIT || modalType == MODAL_TYPE.VIEW) && `(${currentMyRequest?.sequence})`}</span>
              </Flex>
              <span style={{ color: "#667085", fontWeight: "normal", fontSize: "14px" }}>{t("leave_request.create.modal")}</span></Flex>,
          width: 510,
          content: (
            <LeaveForm
              setremainingLeaveDays={setremainingLeaveDays}
              initialValues={currentMyRequest}
              leaveGroupOptions={modifiedLeaveGroupOptions}
              onDraft={onDraft}
              onCancel={onCancel}
              onSubmit={onSubmit}
              onReject={onReject}
              onDeleteFile={onDeleteFile}
              modalType={modalType}
              onAttachFileChange={onAttachFileChange}
              onDelete={onDelete}
            />
          ),
        };
      case MY_REQUEST_TYPE.OFFSITE_WORK:
        return {
          title: <Flex gap={8}>
            <span>{t('offsite_work_request')}</span>
            <span>{(modalType == MODAL_TYPE.EDIT || modalType == MODAL_TYPE.VIEW) && `(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <OffsiteForm
              initialValues={currentMyRequest}
              modifiedOffSiteOptions={modifiedOffSiteOptions}
              onDraft={onDraft}
              modalType={modalType}
              onCancel={onCancel}
              onSubmit={onSubmit}
              onDelete={onDelete}
              onAttachFileChange={onAttachFileChange}
              onReject={onReject}
              onOffsiteWorkTypeChange={onOffsiteWorkTypeChange}
              modifiedWorkInLocationOption={modifiedWorkInLocationOption}
            />
          ),
        };
      case MY_REQUEST_TYPE.REDEEM_TIME:
        return {
          title: t('redeem-time-request'),
          width: 510,
          content: (
            <RedeemTimeForm
              initialValues={currentMyRequest}
              onDraft={onDraft}
              onCancel={onCancel}
              modalType={modalType}
              onSubmit={onSubmit}
              collectTimeOptions={modifiedCollectTimeOptions}
            />
          ),
        };
      case MY_REQUEST_TYPE.ENDORSE_TIME:
        return {
          title: <Flex gap={8}>
            <span>{t('endorse-time-request')}</span>
            <span>{(modalType == MODAL_TYPE.EDIT || modalType == MODAL_TYPE.VIEW) && `(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <EndorseTimeForm
              initialValues={currentMyRequest}
              onDraft={onDraft}
              modalType={modalType}
              onCancel={onCancel}
              onSubmit={onSubmit}
              onDeleteFile={onDeleteFile}
              onAttachFileChange={onAttachFileChange}
              onDelete={onDelete}
              onReject={onReject}
            />
          ),
        };
      case MY_REQUEST_TYPE.OVERTIME:
        return {
          title: <Flex gap={8}>
            <span>{t('ot_request')}</span>
            <span>{(modalType == MODAL_TYPE.EDIT || modalType == MODAL_TYPE.VIEW) && `(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <OvertimeForm
              initialValues={currentMyRequest}
              currentOvertime={currentOvertime}
              onDraft={onDraft}
              onCancel={onCancel}
              onSubmit={onSubmit}
              onDeleteFile={onDeleteFile}
              modalType={modalType}
              onAttachFileChange={onAttachFileChange}
              onDelete={onDelete}
              onReject={onReject}
            />
          ),
        };
      case MY_REQUEST_TYPE.COLLECT_TIME:
        return {
          title: t('collect-time-request'),
          width: 510,
          content: (
            <CollectTimeForm
              initialValues={currentMyRequest}
              onDraft={onDraft}
              modalType={modalType}
              onCancel={onCancel}
              onSubmit={onSubmit}
            />
          ),
        };
      case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
        return {
          title: t('document_request.header'),
          width: 510,
          content: (
            <DocumentForm
              initialValues={currentMyRequest}
              documentTypeOptions={modifiedDocumentTypeOptions}
              countryOptions={modifiedCountryOptions}
              modalType={modalType}
              onDraft={onDraft}
              onCancel={onCancel}
              onSubmit={onSubmit}
              onReject={onReject}
              onDelete={onDelete}
              exportDocumentRequest={exportDocumentRequest}
              isPDFLoading={isPDFLoading}
            />
          ),
        };
      case MY_REQUEST_TYPE.CHANGE_SHIFT:
        return {
          title: ((swapChangeShift === '' || swapChangeShift === null) && changeShiftType === 'SWAP')
            || swapChangeShift === 'SWAP'
            ? t('changeshift.label.swapshift')
            : t('changeshift.label.changeshift'),
          width: 987,
          content: (
            <SwapShiftForm
              initialValues={currentMyRequest}
              switchByOptions={modifiedSwitchByOptions}
              switchWithOptions={modifiedSwitchWithOptions}
              startDate={startDate}
              onDraft={onDraft}
              onCancel={onCancel}
              modalType={modalType}
              onSubmit={onSubmit}
              onChange={onDateChange}
              onSwitchWithChange={onSwitchWithChange}
              myCurrentShift={modifiedMyShift}
              approver={modifiedApprover}
              newShiftRequest={modifiedEmployeeSwapShift}
              onTypeChange={onChangeShiftTypeChange}
              changeShiftType={changeShiftType}
              swapChangeShift={swapChangeShift}
              attendanceSettingShift={modifiedAttendanceSettingShift}
            />
          ),
        };
      case MY_REQUEST_TYPE.WARNING_LETTER:
        return {
          title: t("warning_letter.header"),
          width: 987,
          content: (
            <WarningLetterForm
              initialValues={currentMyRequest}
              employeeOptions={modifiedEmployeeOptions}
              penaltiesOptions={modifiedPenaltiesOptions}
              companyRegulationOptions={modifiedCompanyRegulationOptions}
              modalType={modalType}
              onPreviewPdf={onPreviewPdf}
              onDownload={onDownloadWarningLetter}
              isDownloading={isWarningPdfLoading}
              onCancel={onCancel}
              onSubmit={onSubmit}
              onDraft={onDraft}

            />
          ),
        };


      case MY_REQUEST_TYPE.EXPENSE:
        const tabItems = [
          {
            key: "1",
            label: t("employee.label.description"),
            children: (
              <EditExpenseForm
                form={form}
                initialValues={currentMyRequest}
                isViewExpenseForm={true}
                dropdownProjectByEmployeeId={dropdownProjectByEmployeeId}
                EmployeeWelfareDropdown={modifiedWelfareType}
                CommonTypeByCode={modifiedCommonTypeByCode}
                setIsExpenseModalOpen={setModalOpen}
                onReject={onReject}
              />
            ),
          },
          ...(currentMyRequest?.approveStatusEn !== 'Draft' ? [{
            key: "2",
            label: t("workflow.header"),
            children: (
              <ExpenseWorkflow
                currentExpenseWorkflow={currentExpenseWorkflow}
                setIsExpenseModalOpen={setModalOpen}
              />
            )
          }] : [])
        ];

        return {
          title: <Flex gap={8}>
            <span>{t("expense_request.header")}</span>
            <span>{(modalType == MODAL_TYPE.VIEW) && `(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 576,
          content: (
            <ConfigProvider theme={{
              components: {
                Tabs: {
                  itemHoverColor: "var(--tab-color)",
                  itemActiveColor: "var(--tab-color)"
                },
              },
            }}>
              <Tabs defaultActiveKey={activeTabKey} onChange={setActiveTabKey} items={tabItems} />
            </ConfigProvider>
          )
        }
      default:
        return {};
    }
  }, [selectedMenu, t, currentMyRequest, modifiedLeaveGroupOptions, onReject
    , onDraft, onSubmit, modalType, modifiedOffSiteOptions, modifiedCollectTimeOptions,
    currentOvertime, modifiedDocumentTypeOptions, modifiedCountryOptions,
    swapChangeShift, changeShiftType, modifiedSwitchByOptions, modifiedSwitchWithOptions,
    startDate, onDateChange, onSwitchWithChange, modifiedMyShift, modifiedApprover,
    modifiedEmployeeSwapShift, modifiedAttendanceSettingShift, modifiedPenaltiesOptions,
    modifiedCompanyRegulationOptions, onOffsiteWorkTypeChange,
    modifiedWorkInLocationOption]);


  const getPage = useCallback(
    ({ isEmployee }) => {
      switch (selectedMenu) {
        case MY_REQUEST_TYPE.LEAVE:
          return (
            <LeaveTable
              modalType={modalType}
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.OFFSITE_WORK:
          return (
            <OffsiteWorkTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              modalType={modalType}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.REDEEM_TIME:
          return (
            <RedeemTimeTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.ENDORSE_TIME:
          return (
            <EndorseTimeTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.OVERTIME:
          return (
            <OvertimeTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.COLLECT_TIME:
          return (
            <CollectTimeTable
              isEmponViewloyee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
          return (
            <DocumentRequestTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.CHANGE_SHIFT:
          return (
            <ChangeShiftTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onEdit={onEdit}
              onView={onView}
              // onEditSwapShift={onEditSwapShift}
              onDelete={onDelete}
            />
          );
        case MY_REQUEST_TYPE.WARNING_LETTER:
          return (
            <WarningLetterTable
              isEmployee={isEmployee}
              isLoading={isLoading}
              dataSource={myDocumentList}
              pagination={pagination}
              onChange={onChange}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          );

        case MY_REQUEST_TYPE.EXPENSE:
          return (
            <ExpenseTableList
              dataSource={myDocumentList}
              isEmployee={isEmployee}
              handleView={onView}
              onPageChange={onChange}
              pagination={pagination}
            />
          )
        default:
          return <></>;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMenu, modalType, isLoading, myDocumentList, pagination]);



  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
      setUseFilter(false);
      setParamsSearch([])
    },
    [setMenu]
  );

  const modalHistory = useCallback(() => {
    switch (selectedMenu) {
      case MY_REQUEST_TYPE.LEAVE:
        return (
          <LeaveTable
            modalType={modalType}
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.OFFSITE_WORK:
        return (
          <OffsiteWorkTable
            isHistory={true}
            isLoading={isLoading}
            modalType={modalType}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.REDEEM_TIME:
        return (
          <RedeemTimeTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.ENDORSE_TIME:
        return (
          <EndorseTimeTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.OVERTIME:
        return (
          <OvertimeTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.COLLECT_TIME:
        return (
          <CollectTimeTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.DOCUMENT_REQUEST:
        return (
          <DocumentRequestTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.CHANGE_SHIFT:
        return (
          <ChangeShiftTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      case MY_REQUEST_TYPE.WARNING_LETTER:
        return (
          <WarningLetterTable
            isHistory={true}
            isLoading={isLoading}
            dataSource={myDocumentList}
            pagination={pagination}
            onChange={onChangeHistory}
          />
        );
      default:
        return <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMenu, modalType, isLoading, myDocumentList, pagination])

  const handleOpenModal = useCallback(() => {
    setIsModalHistoryOpen(true);
    getMyRequestList({ page: 0, size: 10, type: 'HISTORY' });
  }, [getMyRequestList]);

  const handleOk = () => {
    setIsModalHistoryOpen(false);
  };

  const handleCancelModal = useCallback(() => {
    setIsModalHistoryOpen(false);
    getMyRequestList({
      page: 0,
      size: 10,
      type: 'SEARCH'
    });
  }, [getMyRequestList]);

  const onChange = useCallback(
    (tablePagination, tableFilters, tableSorter) => {
      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];
      setSorter(modifiedSorter);

      if (selectedMenu === MY_REQUEST_TYPE.EXPENSE) {
        const modifiedParams = toParams({
          page: tablePagination?.current - 1,
          size: tablePagination?.pageSize,
          pageSize: tablePagination?.pageSize,
          current: tablePagination?.current - 1,
          sortBy: modifiedSorter,
        });
        getMyRequestList(modifiedParams);
      } else {
        const modifiedParams = toParams({
          pagination: {
            page: tablePagination.current - 1,
            pageSize: tablePagination.pageSize,
          },
          sortBy: modifiedSorter,
          type: 'SEARCH',
        });
        setPagination({ ...modifiedParams?.pagination });
        getMyRequestList(modifiedParams);
      }
    },
    [getMyRequestList, selectedMenu]
  );

  const onChangeHistory = useCallback(
    (tablePagination, _, tableSorter) => {
      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];
      setSorter(modifiedSorter);
      const modifiedParams = toParams({
        pagination: {
          page: tablePagination.current - 1,
          pageSize: tablePagination.pageSize,
        },
        sortBy: modifiedSorter,
        type: 'HISTORY'
      });
      setPagination({ ...modifiedParams?.pagination });
      // TODO: If sorting or filtering has changed, Change page to 0
      getMyRequestList(modifiedParams);
    },
    [getMyRequestList]
  );

  const getCollectTime = useCallback(async () => {
    try {
      const response = await services.getCollectTimeDropdown({
        companyId: currentCompany,
        employeeId: params?.id ? params?.id : currentEmployee,
        actionId: currentEmployee,
      })
      dispatch(setCollectTime(response?.data))
    } catch (error) {
      message.error(t("common.error"))
    }
  }, [currentCompany, currentEmployee, dispatch])

  const getCompanyRegulation = useCallback(async () => {
    try {
      const response = await services.getCompanyRegulation({
        companyId: currentCompany,
        employeeId: params?.id ? params?.id : currentEmployee,
        actionId: currentEmployee,
      })
      dispatch(setCompanyRegulations(response?.data))
    } catch (error) {
      message.error(t("common.error"))
    }
  }, [currentCompany,
    currentEmployee,
    currentEmployee])



  //---------------- EFFECT ----------------
  useEffect(() => {
    //   const key = storage.sessionStorage.getItem("config.menu");
    //   if (MY_REQUEST_PAGE_LIST.includes(key)) {
    //     setMenu(key);
    //   } else {
    //     setMenu(MY_REQUEST_TYPE.LEAVE);
    //   }
    setChangeShiftType("SWAP")
    if (typeof currentCompany !== "object") {
      getMyRequestList({
        page: 0,
        size: 10,
        type: 'SEARCH'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedMenu]);

  useEffect(() => {
    if (currentCompany) {
      getCompanyRegulation()
      getAttendanceSettingShift()
      getCompanyOvertime();
      getLeaveGroupOptions();
      getOffSiteOptions();
      getEmployeeOptions();
      getPenaltiesOptions();
      getSwitchByOptionsOptions();
      getSwitchWithOptionsOptions();
      getCompanyRegulationOptions();
      getDocumentTypeOptions();
      getCountryOptions();
      getDropdownWelfareSubTypeByCode();
    }

  }, [currentCompany]);


  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);

  useEffect(() => {
    if (currentCompany && switchWith && startDate) {
      getEmployeeSwapShift()
    }
  }, [currentCompany, getEmployeeSwapShift, startDate, switchWith])

  useEffect(() => {
    if (currentCompany && currentEmployee && startDate) {
      getMyShift()
    }
  }, [currentCompany, currentEmployee, getMyShift, startDate])

  return {
    leaveGroupOptions: modifiedLeaveGroupOptions,
    modifiedEmployeeOptions,
    modifiedDocumentTypeOptions,
    modifiedOffSiteOptions,
    selectedMenu,
    modalType,
    modalProps,
    isModalOpen,
    isModalHistoryOpen,
    onEdit,
    onDraft,
    onSearch,
    getPage,
    onCreate,
    onCancel,
    onView,
    handleMenuChange,
    handleOpenModal,
    handleOk,
    handleCancelModal,
    modalHistory,
    modalRecalOt,
    setOpenRecal,
    useFilter,
    setUseFilter,
    onDeleteFile,
    dropdownWelfareSubTypeByCode: modifiedWelfare,
    modifiedWorkInLocationOption,
    onOffsiteWorkTypeChange
  };
}

export default useMyRequest;
